import css from './TransparentWrapper.module.scss'
import React, { PropsWithChildren } from 'react'

interface Props {
  padding?: boolean
  removeRightPadding?: boolean
}

const TransparentWrapper: React.FC<PropsWithChildren<Props>> = ({
  children,
  padding = true,
  removeRightPadding = false,
}) => {
  return (
    <div className={`${css.home_transparentwrapper_container} ${padding ? css.with_padding : ''}`}>
      <div className={css.boxed}>
        <div className={`${css.wrapped_content} ${removeRightPadding ? css.remove_right_padding : ''}`}>{children}</div>
      </div>
    </div>
  )
}

export default TransparentWrapper
